enum GlobalStoresIdentifier {
  PLATFORM_STORE = 'platformStore',
  USER_STORE = 'userStore',
  NOTIFICATION_STORE = 'notificationStore',
  CONTACTS_STORE = 'contactsStore',
}

export default GlobalStoresIdentifier;
